/**
 * @file Cancel PlanMacro Action
 * @author Tzi Yang Lum
*/
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
import { BreezeService } from '../../breeze.service';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
var CancelPlanMacroAction = /** @class */ (function (_super) {
    tslib_1.__extends(CancelPlanMacroAction, _super);
    /**
     * Creates an instance of CancelPlanMacroAction.
     * @param {DomainService} domainService
     */
    function CancelPlanMacroAction(domainService) {
        var _this = _super.call(this, 'sym-icon-cancel', 'APP.MISC.PLANMACRO.CANCEL') || this;
        _this.domainService = domainService;
        /**
         * The success labelkey
         */
        _this.successLabelKey = 'APP.DOMAIN.PLANMACRO_SCRIPTCANCEL_SUCCESSFULLY';
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionInput} input The action configuration
     */
    CancelPlanMacroAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.subscriptionPool.add(BreezeService.invokeMethod(input.item, 'ScriptRun', [-1])
                            .pipe(mergeMap(function (value) {
                            return _this.domainService.saveChanges(function (error) {
                                if (error) {
                                    reject({ labelKey: 'APP.DOMAIN.PLANMACRO_SCRIPTCANCEL_UNSUCCESSFULLY', message: error });
                                }
                            });
                        }))
                            .subscribe(function (response) {
                            resolve(_this.successLabelKey);
                        }));
                    })];
            });
        });
    };
    CancelPlanMacroAction.prototype.isDisabled = function () {
        return false;
    };
    return CancelPlanMacroAction;
}(ActionBase));
export { CancelPlanMacroAction };
